import React, { useRef, useState } from "react";

import { useMutation } from "react-query";
import { toast } from "react-toastify";

import { postNationalites } from "../../../../MyApi/sb/natonalities";

import PageHeader from "../../../../Components/UI/PageHeader";
import AddNationality from "../../../../Components/sb/nationalities/nationalitiesStore/AddNationality"




const NationalitiesStore = () => {
  const [nationalityName, setNationalityName] = useState("");

  const [imageFile, setImageFile] =useState([])
  const [active ,setActive] = useState(1)
  const fileRef =useRef(null)
  const mutation = useMutation(
    "postNationalities",
    (postData) => postNationalites(postData),
    {
      onSuccess: (data) => {
        toast.success(`${data.message}`);
        setNationalityName("")
        setImageFile("")
        fileRef.current.value =""
   
      },
      onError:(error)=>{
          toast.error(`${error.response.data.message}`)
      }
    }
  );


  const handlePostRequest = () => {
    const formData = new FormData();
    if (imageFile) {
      formData.append("image", imageFile);
    }
    formData.append("name", nationalityName);
    formData.append("active", active);
    mutation.mutate(formData );
  };
  const isDisabled = () => {
    return !(nationalityName );
 
  };
  return (
    <div>
      <PageHeader
        title="Add Nationality"
        saveButton={true}
        showBack={true}
        isdisbled={isDisabled}
        handlePostRequest={handlePostRequest}
      />
      <AddNationality  fileRef={fileRef}  imageFile={imageFile} nationalityName={nationalityName} setNationalityName={setNationalityName} active={active} setActive={setActive} setImageFile={setImageFile} />
    </div>
  ); 
};

export default NationalitiesStore;
